import { render, staticRenderFns } from "./cp.vue?vue&type=template&id=f5dcad96&scoped=true"
import script from "./cp.vue?vue&type=script&lang=js"
export * from "./cp.vue?vue&type=script&lang=js"
import style0 from "./cp.vue?vue&type=style&index=0&id=f5dcad96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dcad96",
  null
  
)

export default component.exports